import React, { useState, useEffect } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import NewButton from '../Buttons/NewButton';


const  SafetyModal = (props) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [show, setShow] = useState(props.show)
    const [errorText, setErrorText] = useState("")

    useEffect(() => {
        setShow(props.show)

    },[props.show])

    
    const handleClose = () => {
        props.onClose()
      //  setShow(false)
    }


    const clearContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.clear_history")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => props.onClose()} alt="..." /> 
                </div>
                <p className="grey-blue pt-3">{t("settings.clear_history_body")}</p>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => props.onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => props.clearHistory()} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.clear_history")}</NewButton>
                </div>
            </div>
        )
    }

    const logoutContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.logout")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => props.onClose()} alt="..." /> 
                </div>
                <p className="grey-blue pt-3">{t("settings.logout_all_body")}</p>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => props.onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => props.logoutAll()} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.logout_all_sessions")}</NewButton>
                </div>
            </div>
        )
    }

    const typeRender = () => {
        switch(props.type){
            case "clear": return clearContent()
            case "logout": return logoutContent()
            default: return null
        }
    }
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100 grey-blue">
                    {typeRender()}
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default SafetyModal;